import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/cn"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "bg-brand-600 text-white hover:bg-brand-700",
        secondary:
          "bg-gray-600 text-white hover:bg-gray-700",
        destructive:
          "bg-red-600 text-white hover:bg-red-700",
        outline: "text-brand-600 hover:bg-brand-50 hover:text-brand-600",
        statusActive: "border-transparent bg-brand-50 text-brand-700 hover:bg-brand-50/80",
        statusInactive: "border-transparent bg-gray-50 text-gray-700 hover:bg-gray-50/80",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
  VariantProps<typeof badgeVariants> { }

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
